import axios from "axios";

const baseURL =
  process.env.VUE_APP_NODE_ENVIRONMENT === "production"
    ? "https://ideascope.onrender.com"
    : "http://localhost:4000";

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
